const classMap = {
  submenuItem: 'js-submenu-item',
  submenuItemChildren: 'js-submenu-item-children'
}

export default class Submenu {
  mount() {
    document.addEventListener('click', this.onHandlerSubmenu.bind(this))

    if(!this.isMobile()){
      document.addEventListener('mouseover', this.onHandlerSubmenu.bind(this))
      document.addEventListener('mouseout', this.onHandlerSubmenu.bind(this))
    }
  }

  isMobile () {
    return window.innerWidth <= 768
  }

  getHeightSubmenuItemChildren(element) {
    const height = element.querySelector('.c-submenu__item-children ul').clientHeight
    const list = element.closest(`ul`)
    list.style['min-height'] = (height) + 'px'
  }

  openSubmenuItems(element) {
    // remove active all elements
    this.closeSubmenuGroups(element)

    // in mobile required toggle
    if(this.isMobile()){
      element.classList.toggle('active')
      const expanded = element.getAttribute('aria-expanded') === 'true'
      element.setAttribute('aria-expanded', !expanded)

       // toggle in aria-hidden
      const submenuItemChildren = element.querySelector(`.${classMap.submenuItemChildren}`)
      submenuItemChildren.setAttribute('aria-hidden', expanded);
    } else {
      element.classList.add('active')
      element.setAttribute('aria-expanded', true)
      // set aria-hidden is false
      const submenuItemChildren = element.querySelector(`.${classMap.submenuItemChildren}`)
      submenuItemChildren.setAttribute('aria-hidden', false);

      this.getHeightSubmenuItemChildren(element)
    }
  }

  /**
   * open submenu in desktop
   */
  openFirstSubmenuItems(element){
    const elSubmenuGroup = element.querySelector(`.${classMap.submenuItem}:first-child`)
    this.openSubmenuItems(elSubmenuGroup)
  }

  closeSubmenuGroups(element) {
    document.querySelectorAll(`.${classMap.submenuItem}.active`).forEach(activeItem => {
      if(activeItem===element) return
      activeItem.classList.remove('active')
      activeItem.setAttribute('aria-expanded', false)

      // set aria-hidden is false
      const submenuItemChildren = activeItem.querySelector(`.${classMap.submenuItemChildren}`)
      submenuItemChildren.setAttribute('aria-hidden', true);
    })
  }

  onHandlerSubmenu({ target }){
    const bubblingTarget = target.closest(`.${classMap.submenuItem}`)
    if (!bubblingTarget) return

    this.openSubmenuItems(bubblingTarget);
  }
}
